export const LOADING_PAGE_DASHBOARD = 'LOADING_PAGE_DASHBOARD';

export const LOADING_WEATHER = 'LOADING_WEATHER';
export const RECEIVE_WEATHER = 'RECEIVE_WEATHER';
export const ERROR_WEATHER = 'ERROR_WEATHER';
